import { render, staticRenderFns } from "./PaymentLegalNotices.vue?vue&type=template&id=c4a39c3c&scoped=true"
import script from "./PaymentLegalNotices.vue?vue&type=script&lang=js"
export * from "./PaymentLegalNotices.vue?vue&type=script&lang=js"
import style0 from "./PaymentLegalNotices.vue?vue&type=style&index=0&id=c4a39c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a39c3c",
  null
  
)

export default component.exports